import FormBuilder from "@feature/pages/FormBuilder";
import FormSubmit from "@feature/pages/FormSubmit";
import { Update } from "@mui/icons-material";
import { Form } from "react-router";


export const featurePaths = {
  EmailTemplateList: "/emailtemplatelist",
  CreateEmailTemplate: "/createemailtemplate",
  FormTemplate: "/forms/formtemplatelist",
  CreateFormTemplate: "/forms/createformtemplate",
  UpdateFormTemplate: "/forms/updateformtemplate",
  AddFormContent: "/forms/updateformtemplate/addformcontent",
  FormAllocation: "/forms/formallocation",
  FormSummary: "/forms/formsummary",
  SendLoginDetails: "/forms/sendlogindetails",
  FormSubmissionList: "/forms/formsubmissionlist",
  ApproveFormSubmission: "/forms/approveformsubmission",
  SubmitForm: "/forms/submitform",
  FormInfoSection: "/forms/forminfosection",
  FormSubmission: "/forms/formsubmission",
  FormBuilder: "/forms/formbuilder",
  FormSubmit: "/forms/formsubmit",
  UpdateFormSubmission: "/forms/updateformsubmission",
};
